import { useEffect, useState } from "react";
import { getActiveSalaryCategories } from "../../../services/salaryCategory.js";

/**
 * Every active payhead category, grouped by section - shared by the
 * Wage Rate and Payroll Template forms (which need it both to render
 * PayheadRowsEditor and to validate/preview against it) so there's one
 * fetch, not two independent copies drifting apart.
 */
const useActiveSalaryCategories = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await getActiveSalaryCategories();
        setCategories(response?.data?.data || []);
      } catch (error) {
        console.error("Error fetching salary categories:", error);
      }
    };
    fetchCategories();
  }, []);

  return categories;
};

export default useActiveSalaryCategories;
